import { Block, Flex, SimpleInput } from '@aloft/toolkit-sui';

import { setDepreciation } from '../../../../redux/features/actions/setDepreciation.ts';
import { selectFunctionalDepreciationDisplay } from '../../../../redux/features/selectors/depreciationSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks.ts';
import { RootState } from '../../../../redux/types.ts';

export function FunctionalDepreciation({ id }: { id: string }) {
  const dispatch = useAppDispatch();
  const value = useAppSelector((state: RootState) =>
    selectFunctionalDepreciationDisplay(state, id),
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      setDepreciation({
        id,
        field: 'functionalDepreciation',
        newValue: Number(event.target.value),
      }),
    );
  };

  return (
    <Block>
      <Flex gap="1rem" width="100%" justifyContent="space-between" alignItems="center">
        <SimpleInput
          id="functionalDepreciation"
          onChange={handleChange}
          type="number"
          precision={0}
          size="sm"
          prefix="$"
          useSeparator
          value={value}
          min={0}
          label="Functional Obsolescence"
          labelTypographyVariant="h4"
        />
      </Flex>
    </Block>
  );
}
